<template>
  <div class="breadcrumb">
    <div class="wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Breadcrumb.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/Breadcrumb.vue